import React from 'react';
import { useTranslation } from 'react-i18next';
import './product-standard-premium.css';

const ProdStandardPremium = ({ standard }) => {
  const { t } = useTranslation();
  const text = standard === 'oui' ? 'standard' : 'premium';


  return (
    <span className={`product-standard-premium d-inline ${text}`}>

      <a className="d-inline-block" >{text.substring(0, 2).toUpperCase()}</a>
    </span>
  );
};

export default ProdStandardPremium;
